<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import RestriccionesAgregarPagination from "@/components/standard/RestriccionesSeguimientos/RestriccionesAgregarPagination";
import { sendNotification } from "@/utils/helpers/notification";
import { required } from "vuelidate/lib/validators";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import ItemAPI from "@/services/items/itemsAPI";
import restriccionesColaboracionesAgregarAPI from "../../../services/standards/restriccionesColaboraciones/restriccionesColaboracionesAgregarAPI";
import { dateFormat } from "../../../utils/helpers/format";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Restricciones y recomendaciones laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
    RestriccionesAgregarPagination,
  },
  data() {
    return {
      title: "3.1.6-1 Restricciones y recomendaciones laborales",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Restricciones y recomendaciones laborales",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/restricciones-colaboraciones`,
        },
        {
          text: "Agregar",
          active: true,
        },
      ],
      userSelected: null,
      usersList: [],
      lista: [],
      submitted: false,

      item: null,

      itemData: null,

      file: null,
      listaII: null,

      addRecomendacion: {
        date: null,
        entity: null,
        restriction: null,
        file: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      // Archivo anexo (opcional) que se sube al bucket y se guarda en el registro
      restrictionFile: null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      company: "",
      deleteCount: 0,
      companyID: this.$store.getters["company/getCompany"].id || null,
      company: this.$store.getters["company/getCompany"] || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading1: true,
      search: "",
    };
  },
  validations: {
    addRecomendacion: {
      date: {
        required,
      },
    },
  },
  methods: {
    fetch() {
      this.loading1 = true;
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(28)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getList() {
      restriccionesColaboracionesAgregarAPI
        .get(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.data.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    onRestrictionFile(e) {
      this.restrictionFile = (e.target.files && e.target.files[0]) || null;
    },

    async save() {
      this.submitted = true;
      this.loading1 = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading1 = false;
        return;
      }
      try {
        // Si se anexó un archivo, subirlo al bucket y guardar su URL en el registro.
        if (this.restrictionFile) {
          const base =
            process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
          const nit = this.nit || this.$store.getters["company/getCompany"].nit;
          const path = `${base}/${nit}/3.1.6/${Date.now()}_${this.restrictionFile.name}`;
          const ok = await uploadDocument(path, this.restrictionFile);
          if (!ok) throw new Error("No se pudo subir el archivo");
          this.addRecomendacion.file = `${process.env.VUE_APP_BUCKET}/${path}`;
        }

        await restriccionesColaboracionesAgregarAPI.save(this.addRecomendacion);
        await newScoresAPI.calculateScores({
          companies_id: this.companyID,
          item_id: 28,
          status: "Pendiente",
        });

        this.loading1 = false;
        Swal.fire({
          title: "¡Éxito!",
          text: "¡Se ha registrado con éxito!",
          type: "success",
          icon: "success",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        setTimeout(() => window.location.reload(), 1200);
      } catch (error) {
        this.loading1 = false;
        this.submitted = false;
        console.log(error);
        Swal.fire({
          title: "Error",
          text: "¡No se ha podido registrar!",
          icon: "error",
          type: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deleteRecomendacion(id) {
      restriccionesColaboracionesAgregarAPI
        .delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 28,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        const url = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATO_RESTRICCIONES_RECOMENDACIONES_LABORALES.docx";
        window.location.href = url;
        setTimeout(() => { window.location.reload(); }, 2000);
      } catch (error) {
        console.log(error);
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 28)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    dateConvert(date) {
      return dateFormat(date);
    },

  },

  mounted() {
    this.getUsers();
    this.getList();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa deberá realizar las evaluaciones médicas
                      ocupacionales de ingreso, periódicas, de egreso, post
                      incapacidad y por cambio de ocupación, dando cumplimiento
                      a lo establecido por la resolución 2346 de 2007. Se deberá
                      almacenar los conceptos de aptitud laboral que respalden
                      la realización de las evaluaciones, además la empresa
                      deberá contar con la documentación de la IPS que realice
                      las evaluaciones, como son: Licencia en SST y certificado
                      de habilitación.
                    </p>
                  </CheckModal>
                </div>

              </div>

              <hr>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Nombre del colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="addRecomendacion.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha" label-for="date_exam">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="date" id="date_exam"
                      v-model="addRecomendacion.date" :class="{
                        'is-invalid':
                          $v.addRecomendacion.date.$error && submitted,
                      }">
                    </b-form-input>
                    <div v-if="submitted && $v.addRecomendacion.date.$error">
                      <small v-if="!$v.addRecomendacion.date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group id="cycle" label-for="cycle" class="col-md-6 px-2" label="Entidad">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="addRecomendacion.entity">
                      <b-form-select-option value="ARL">
                        ARL
                      </b-form-select-option>
                      <b-form-select-option value="EPS">
                        EPS
                      </b-form-select-option>
                      <b-form-select-option value="Otro">
                        Otro
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Restricción y/o recomendación" label-for="file">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="text"
                      v-model="addRecomendacion.restriction" maxlength="30">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Archivo (anexo, opcional)" label-for="restriction_file">
                    <b-form-file id="restriction_file" ref="restrictionFile"
                      :disabled="!getRole('Crear') || !allowAccess()" browse-text="Buscar"
                      placeholder="Selecciona un archivo..." drop-placeholder="Suelta acá..."
                      @change="onRestrictionFile"
                      accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,image/*">
                    </b-form-file>
                    <small class="text-muted">Documento diligenciado (acta, concepto EPS/ARL, certificado, etc.).</small>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button @click="print" class="btn btn-primary mx-1" id="tooltip">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Descargar formato de restricciones y recomendaciones laborales
                  </button>

                  <button type="submit" class="btn btn-primary":disabled="submitted">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar') || !allowAccess()" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar" autocomplete="off"></b-form-input>
                              </div>
                              <div class="col-sm-1 pl-5">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <div v-if="!loading1">
                          <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                            <thead>
                              <tr>
                                <th>Fecha</th>
                                <th>Colaborador/Aprendiz</th>

                                <th class="text-center align-middle">
                                  Entidad
                                </th>
                                <th class="text-center align-middle">
                                  Fecha de la recomendación
                                </th>
                                <th class="text-center align-middle">
                                  Restricción
                                </th>
                                <th class="text-center align-middle">
                                  Archivo
                                </th>

                                <th class="text-center align-middle">
                                  Acciones
                                </th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr v-for="dato in lista" :key="dato.id">
                                <td>
                                  {{ dateConvert(dato.created_at) }}
                                </td>
                                <td>
                                  {{ dato.full_name }}
                                </td>
                                <td class="text-center align-middle">
                                  {{ dato.entity }}
                                </td>
                                <td class="text-center align-middle">
                                  {{ dato.date }}
                                </td>

                                <td class="text-center align-middle">
                                  {{ dato.restriction }}
                                </td>

                                <td class="text-center align-middle">
                                  <div v-if="dato.file === null">
                                    <h6>No hay archivo disponible</h6>
                                  </div>
                                  <div v-else>
                                    <button :disabled="!allowAccess()" style="
                                        background-color: transparent !important;
                                        border: none;
                                      " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                      <i class="mdi mdi-cloud-download"></i>
                                    </button>
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  <div class="col-sm-12">
                                    <b-dropdown variant="primary" :disabled="!allowAccess()">
                                      <template v-slot:button-content>
                                        <i class="mdi mdi-eye"></i>
                                      </template>
                                      <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                        " :to="{
                                          path: `/forms/estandares/restricciones-recomendaciones-editar/${dato.id}`,
                                        }">
                                        Editar
                                      </b-dropdown-item>
                                      <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                        " v-on:click="
                                          deleteRecomendacion(dato.id)
                                          ">Eliminar</b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else>
                          <div class="text-center pt-2">
                            <b-spinner variant="primary" label="Loading..."></b-spinner>
                          </div>
                        </div>
                        <div>
                          <RestriccionesAgregarPagination @loading1="(load) => (loading1 = load)" ref="paginator"
                            :search="search" @fetch="(items) => (lista = items)" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
